import React from 'react'
import ArticleCreateForm from '../../forms/ArticleCreateForm'

function ArticleAdminCreate() {
  return (
    <div>
        <ArticleCreateForm/>
    </div>
  )
}

export default ArticleAdminCreate